const translateOrReturn = (s, translate) => {
    const isTranslationKey = /^([a-zA-Z1-9]|-|_)*:([a-zA-Z1-9]|-|_)*(\.([a-zA-Z1-9]|-|_)*)+$/.test(s);
    if (isTranslationKey) {
        return translate(s);
    }
    return s;
};
const translateErrors = (fieldErrors, translate) => {
    if (!fieldErrors)
        return fieldErrors;
    if (typeof fieldErrors === 'string') {
        return translateOrReturn(fieldErrors, translate);
    }
    if (!Array.isArray(fieldErrors)) {
        const field = fieldErrors;
        return {
            errorCode: field.errorCode,
            errorMessage: translateOrReturn(field.errorMessage, translate),
        };
    }
    if (Array.isArray(fieldErrors) && typeof fieldErrors[0] === 'string') {
        return fieldErrors.map((e) => translateOrReturn(e, translate));
    }
    if (Array.isArray(fieldErrors) && typeof fieldErrors[0] !== 'string') {
        return fieldErrors.map((f) => {
            const field = f;
            return {
                errorCode: field.errorCode,
                errorMessage: translateOrReturn(field.errorMessage, translate),
            };
        });
    }
    return fieldErrors;
};

export { translateErrors };
